import request from '@/utils/request'
import dynamicRequest from '@/utils/dynamicRequest'

// 출력목록 조회
export function getRiskAssessmentOutputList(params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentOutputList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// 출력물
export function getRiskAssessmentOutputReport(params, isProgress) {
  let responseType = 'blob'
  return dynamicRequest({
    url: `/api/getRiskAssessmentOutputReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
    timeout: 1200000
  })
}
